import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Home, Camera, Map, User, Swords } from 'lucide-react';
import { motion } from 'framer-motion';
import { useT } from '../i18n/I18nContext';

const leftItemsBase = [
  { to: '/dashboard', labelKey: 'bottomNav.explore', fallback: 'Explore', icon: Home, testid: 'nav-explore' },
  { to: '/battle',    labelKey: 'bottomNav.battle',  fallback: 'Battle',  icon: Swords, testid: 'nav-battle' },
];
const rightItemsBase = [
  { to: '/map',     labelKey: 'bottomNav.map',     fallback: 'Map',     icon: Map,  testid: 'nav-map' },
  { to: '/profile', labelKey: 'bottomNav.profile', fallback: 'Profile', icon: User, testid: 'nav-profile' },
];

export default function BottomNav() {
  const nav = useNavigate();
  const t = useT();
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md z-50 glass border-t border-white/10 pb-[env(safe-area-inset-bottom)]"
    >
      <div className="wq-bottom-nav-inner relative flex items-center justify-between px-4 pt-3 pb-3">
        {/* Camera FAB */}
        <motion.button
          data-testid="camera-fab"
          whileTap={{ scale: 0.92 }}
          onClick={() => nav('/discover')}
          className="wq-camera-fab absolute left-1/2 -translate-x-1/2 -top-7 h-16 w-16 rounded-full bg-primary flex items-center justify-center border-4 border-[#040A08] text-white pulse-glow"
          aria-label={t('appShell.cameraFabAria', 'Discover species')}
        >
          <Camera className="w-7 h-7" strokeWidth={2} />
        </motion.button>

        {leftItemsBase.map((it) => (
          <TabLink key={it.to} {...it} label={t(it.labelKey, it.fallback)} />
        ))}
        <div className="w-14" />
        {rightItemsBase.map((it) => (
          <TabLink key={it.to} {...it} label={t(it.labelKey, it.fallback)} />
        ))}
      </div>
    </nav>
  );
}

function TabLink({ to, label, icon: Icon, testid }) {
  return (
    <NavLink to={to} data-testid={testid} className="flex-1 flex justify-center">
      {({ isActive }) => (
        <div className={`flex flex-col items-center gap-1 py-1 transition-colors ${isActive ? 'text-accent' : 'text-muted-foreground'}`}>
          <Icon className="w-5 h-5" strokeWidth={1.75} />
          <span className="wq-nav-label text-[10px] uppercase tracking-widest font-medium">{label}</span>
        </div>
      )}
    </NavLink>
  );
}
